import './rubricators.scss';
import './rubricators.js';
